import { config } from '@abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import GetUserLocation from './UserLocation.graphql';

export const useUserLocation = (options) =>
  useCustomQuery(GetUserLocation, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'userLocation',
  });
